import { render, staticRenderFns } from "./AddTenantPage.vue?vue&type=template&id=0a9308e0&"
import script from "./AddTenantPage.vue?vue&type=script&lang=js&"
export * from "./AddTenantPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports